import { LogLevel, type Configuration } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const redirectUri = import.meta.env.VITE_ENTRA_REDIRECT_URI;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    // sessionStorage keeps tokens scoped to the tab and avoids persisting
    // them beyond the browser session.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) console.error(message);
      },
    },
  },
};

// Scope requested at login so the user consents to our API up front.
export const loginRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE],
};

// Scope used when silently acquiring a token for API calls.
export const apiTokenRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE],
};
